import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute , ParamMap} from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';
import { CommerceDataService } from '../../../services/commerce-data.service';
import { environment } from '../../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {
  
  pageName = "Cashout Details";
  modelForm: FormGroup;
  authForm: FormGroup;

  salesBalance = 0;
  availablebalace = 0;
  toDateEarnings = 0;
  requestReference = ''
  showOTP = false

  transactionCharge = 0.0;
  transactionCashoutTotal = 0;
  transactionProcessingTime = ''
  toBankAccountNumber = ''
  toBankAccountName = ''
  dateRequested = ''
  cuurentAvailable = 0
  bankName = ''

  context_id

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    
    this.modelForm = this.formBuilder.group({
        accountNumber: ['', Validators.required], 
        accountFullName: ['', Validators.required], 
        bankName: ['', Validators.required], 
        branchNumber: ['', Validators.required], 
      });

      this.authForm = this.formBuilder.group({
        otp: ['', Validators.required], 
      });

      this.context_id = sessionStorage.getItem('context')

      if(this.context_id != undefined) {
        // this.getOrders(context_id)
        // this.getDeliveries(context_id)
        // this.getSellerProducts(context_id)
        this.getAccountDetails()
      }

  }

  getAccountDetails() {

    let modelObject1 = new FormData();
    modelObject1.append('context', this.context_id);

    this._data.dynamicFormPost(modelObject1, 'ledger-account-details') 
      .pipe(first())
      .subscribe(
        data => {

          this.salesBalance = data['account']['accountBalance'];
          this.availablebalace = data['account']['availableBalance'];
          this.toDateEarnings = data['account']['accountEarnedTotal'];
   
        },
        error => {
          console.log(error);

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

        },

        () => {

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

          //this.router.navigate(['/sellers/account/product-settings/?id='+id]);
            
        }
      );

  }

  cashOutRequest(type) {

    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected');

      $('#buttonText').text('Update Shipping Info ');
      $('#loader').hide();

      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.getCheckoutTransactionDetails();

  }

  getCheckoutTransactionDetails() {

    let modelObject1 = new FormData();

    modelObject1.append('bankAccountNumber', this.modelForm.controls['accountNumber'].value);
    modelObject1.append('bankHolderFullName', this.modelForm.controls['accountFullName'].value);
    modelObject1.append('bankName', this.modelForm.controls['bankName'].value);
    modelObject1.append('bankBranchNumber', this.modelForm.controls['branchNumber'].value);

    this._data.dynamicFormPost(modelObject1, 'create-payout-request') 
      .pipe(first())
      .subscribe(
        data => {

          this.requestReference = data['cashOutDetails']['cashOutreference'];
          this.transactionCharge = data['cashOutDetails']['transactionCharge'];
          this.transactionCashoutTotal = data['cashOutDetails']['cashOutAmount'];
          // this.transactionProcessingTime = data['cashOutDetails']['cashOutreference'];
          this.toBankAccountNumber = data['cashOutDetails']['bankAccountNumber'];
          this.toBankAccountName = data['cashOutDetails']['bankHolderFullName'];
          this.bankName = data['cashOutDetails']['bankName'];
          this.dateRequested = data['cashOutDetails']['dateRequested'];
          this.cuurentAvailable = data['cashOutDetails']['transactionAmount'];
          this.showOTP = true;
   
        },
        error => {
          console.log(error);

          let h = {
            class: "iziToast-warning",
            title:  "Error!",
            message:  error['error_msg'],
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 4200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);

          $('#loader').hide();

        },

        () => {

          let h = {
            class: "iziToast-success",
            title:  "Provide OTP:",
            message:  "An OTP has been sent to your email. Kindly check your email for details!",
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 3200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

          //this.router.navigate(['/sellers/account/product-settings/?id='+id]);
            
        }
      );

  }

  confirmPayout() {

    let modelObject1 = new FormData();

    modelObject1.append('otp', this.authForm.controls['otp'].value);
    modelObject1.append('bankAccountNumber', this.toBankAccountNumber);
    modelObject1.append('bankHolderFullName', this.toBankAccountName);
    modelObject1.append('bankName', this.bankName);
    modelObject1.append('bankBranchNumber', this.modelForm.controls['branchNumber'].value);
    modelObject1.append('referenceNumber', this.requestReference);

    this._data.dynamicFormPost(modelObject1, 'confirm-payout-request') 
      .pipe(first())
      .subscribe(
        data => {

          let h = {
            class: "iziToast-success",
            title:  "Success!",
            message:  "Your payout request has been completed successfully. Payments may take 2 to 3 days to reflect!",
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 4200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);


          $('#loader').hide();

          this.router.navigate(['/sellers/dashboard']);
   
        },
        error => {
          console.log(error);

          let h = {
            class: "iziToast-warning",
            title:  "Error!",
            message:  "Whoops something went wrong. Ensure you provide the correct OTP!",
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 4200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);

          $('#loader').hide();

        },

        () => {

          
            
        }
      );

  }

}
